/**
 * Mabuhay Marquee - Scrolling Announcement Bar
 * FINAL - Bright saturated gradient (Orange → Gold → Cyan)
 */
(function() {
  'use strict';

  const CONFIG = {
    speed: 45,
    gap: 150,
    sparkle: '✦',
    sparkleColor: '#FFD700' // Bright gold for sparkles
  };

  function initMarquee() {
    const utilityBar = document.querySelector('.utility-bar');
    const announcementBar = document.querySelector('.announcement-bar');

    if (!announcementBar || !utilityBar) return;

    const messages = [];
    announcementBar.querySelectorAll('.announcement-bar__message').forEach(el => {
      const text = el.textContent.trim();
      if (text) messages.push(text);
    });

    if (messages.length === 0) return;

    announcementBar.style.display = 'none';

    const marqueeContainer = document.createElement('div');
    marqueeContainer.className = 'mabuhay-marquee-container';
    marqueeContainer.style.cssText = `
      width: 100%;
      overflow: hidden;
      position: relative;
    `;

    const marqueeTrack = document.createElement('div');
    marqueeTrack.className = 'mabuhay-marquee-track';
    marqueeTrack.style.cssText = `
      display: inline-flex;
      white-space: nowrap;
      will-change: transform;
    `;

    const sparkleHTML = `<span class="mabuhay-sparkle">${CONFIG.sparkle}</span>`;
    const combinedMessage = messages.join(` ${CONFIG.sparkle} `) + ` ${CONFIG.sparkle} `;

    const measureSpan = document.createElement('span');
    measureSpan.className = 'mabuhay-message';
    measureSpan.textContent = combinedMessage;

    marqueeTrack.appendChild(measureSpan);
    marqueeContainer.appendChild(marqueeTrack);
    utilityBar.appendChild(marqueeContainer);

    const style = document.createElement('style');
    style.id = 'mabuhay-marquee-style';
    style.textContent = `
      /* Bright saturated gradient - fixed to viewport */
      .mabuhay-message {
        display: inline-block;
        padding-right: ${CONFIG.gap}px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1.5px;
        font-size: 0.9em;
        color: #FFFFFF;
        background: linear-gradient(
          90deg,
          #FF4500 0vw,
          #FFD700 50vw,
          #00FFFF 100vw
        );
        background-attachment: fixed;
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      .mabuhay-sparkle {
        -webkit-text-fill-color: ${CONFIG.sparkleColor};
        color: ${CONFIG.sparkleColor};
      }

      .mabuhay-marquee-track {
        animation: mabuhayScroll var(--scroll-duration, 20s) linear infinite;
      }

      .mabuhay-marquee-track:hover {
        animation-play-state: paused;
      }
    `;
    document.head.appendChild(style);

    function createMessageHTML(text) {
      return text.replace(new RegExp(CONFIG.sparkle, 'g'), sparkleHTML);
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const singleWidth = measureSpan.offsetWidth;
        const screenWidth = window.innerWidth;
        const copiesNeeded = Math.ceil(screenWidth / singleWidth) + 3;

        marqueeTrack.innerHTML = '';

        for (let i = 0; i < copiesNeeded; i++) {
          const span = document.createElement('span');
          span.className = 'mabuhay-message';
          span.innerHTML = createMessageHTML(combinedMessage);
          marqueeTrack.appendChild(span);
        }

        const duration = singleWidth / CONFIG.speed;

        const scrollStyle = document.createElement('style');
        scrollStyle.textContent = `
          @keyframes mabuhayScroll {
            from { transform: translateX(0); }
            to { transform: translateX(-${singleWidth}px); }
          }
          .mabuhay-marquee-track {
            --scroll-duration: ${duration}s;
          }
        `;
        document.head.appendChild(scrollStyle);

        console.log('Mabuhay Marquee FINAL - Bright Gradient');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarquee);
  } else {
    initMarquee();
  }
})();
